/**
 * =========================================================================================
 *     Copyright © 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * =========================================================================================
 *     Description     :   Documentation hub container. The hub now renders self-contained
 *                         static content (doc topics + user/platform guides) with a live
 *                         client-side search — no backend fetch, so it can't empty out or
 *                         fall to a "coming soon" state.
 * =========================================================================================
 */

import React from 'react';
import { DocumentationPage } from './DocumentationPage';

export const DocumentationContainer: React.FC = () => <DocumentationPage />;

export default DocumentationContainer;
